//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props:["term"],
  data() {
    return {
      search: "",
    };
  },
  // watch: {
  //   term(val) {
  //     this.search = term;
  //   }
  // },
  methods: {
    startSearch() {
      if(this.search !== null && this.search !== '') {
        if (this.$route.name === "search-search") {
          this.$nuxt.$emit("search", this.search);
          this.$nuxt.$emit("changeUpperTerm",this.search);
        } else {
          this.$router.push("/search?term=" + this.search);
          this.$emit("clicked", false);
          this.$nuxt.$emit("changeUpperTerm", this.search);
        }
      }
    },
  },
  created() {
    this.$nuxt.$on("changeUpperTerm", (query) => {
      this.search = query;
    });
    this.$nuxt.$on("refreshTerm", (query) => {
      this.search = query;
    });
    if (this.$route.name === "search-search") {
      this.search=this.$route.query.term;
    }
    this.$nuxt.$on("eraseSearch", () => {
      this.search = "";
    });
  },
};
